<template>
    <div>
        <SubscriptionAlert
            origin="banner"
            @close="showModalSubscription = $event"
            :show="showModalSubscription"
            plan=""
            openInicialize
        />
        <div
            v-if="show"
            :class="hasUser ? 'banner-supplier' : 'full-width'"
            class="banner plans-banner fix-position black-banner"
            :style="{ backgroundColor: backgroundColor }"
        >
            <div class="container" :class="{ 'flex-end': loading }">
                <div class="content animated fadeIn" v-if="!loading">
                    <div class="text">
                        <div class="close-icon-wrapper" :style="{ color: fontColor }">
                            <span class="title banner-title">
                                {{ bannerText }}
                            </span>
                            <div @click="closeBanner" class="close-icon">
                                <i
                                    class="
                                        fas
                                        fa-times
                                        material-icons
                                        modal-close
                                        right
                                        show-on-medium-and-down
                                        hide-on-large-only
                                        close-banner
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                    <button
                        class="btn indigo indigo-darken-4 white-text open-banner-modal"
                        type="button"
                        @click="actionButton"
                    >
                        {{ buttonText }}
                    </button>
                </div>

                <div @click="closeBanner">
                    <i class="fas fa-times material-icons modal-close hide-on-med-and-down close-banner"></i>
                </div>
            </div>
        </div>
        <div v-if="showSubscriptionPendingModal" class="full-width payment-pending-banner banner fix-position">
            <div class="container">
                <div class="content">
                    <div class="text">
                        <div class="close-icon-wrapper">
                            <span class="title">Pagamento pendente</span>
                            <div @click="closePaymentPendingBanner" class="close-icon">
                                <i
                                    class="
                                        fas
                                        fa-times
                                        material-icons
                                        modal-close
                                        right
                                        show-on-medium-and-down
                                        hide-on-large-only
                                        close-payment-pending-banner
                                    "
                                    >close</i
                                >
                            </div>
                        </div>
                        <span class="description">Seu pagamento está sendo processado, aguarde alguns instantes.</span>
                    </div>
                </div>
                <div @click="closePaymentPendingBanner">
                    <i
                        class="
                            fas
                            fa-times
                            material-icons
                            modal-close
                            hide-on-med-and-down
                            close-payment-pending-banner
                        "
                    ></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import SubscriptionAlert from '@/components/modal/subscription-alert/';
import { getBannerText } from '@/services/';

export default {
    name: 'FullBanner',
    data: () => ({
        showModalSubscription: false,
        bannerText: '',
        buttonText: 'Fale com um especialista',
        loading: true
    }),
    components: { SubscriptionAlert },
    props: {
        show: {
            type: Boolean,
            required: true,
            twoWay: true
        },
        showSubscriptionPendingModal: {
            type: Boolean,
            required: true,
            twoWay: true
        },
        supplierHasSubscription: Boolean,
        hasUser: Boolean,
        backgroundColor: {
            type: String,
            default: '#26ade2'
        },
        fontColor: {
            type: String,
            default: '#fff'
        }
    },
    async created() {
        await this.getBannerText();
    },
    methods: {
        ...mapActions('user', ['setCrossSellerOnHeader']),
        async getBannerText() {
            this.loading = true;
            try {
                const query = await this.querieStringByText();
                const { results } = await getBannerText(query);
                this.bannerText = results[0][this.getKeyBanner()];
            } catch (error) {
                console.error(error);
                this.bannerText = 'Gostaria de entender qual plano se encaixa no perfil da sua empresa?';
            } finally {
                this.loading = false;
            }
        },
        async querieStringByText() {
            if (this.$route.name === 'CompetitionDashboard' && !this.user.type.hasSubscription) {
                await this.setCrossSellerOnHeader();
                if (this.supplierData.isCrossSeller) {
                    this.buttonText = 'comprar pacote';
                    return '?search=cross_seller';
                } else {
                    return '?search=general';
                }
            } else {
                return '?search=general';
            }
        },
        getKeyBanner() {
            switch (this.$route.name) {
            case 'CompetitionDashboardGuest':
                return 'dashboardText';
            case 'CompetitionDashboard':
                return 'dashboardText';
            case 'GuestContactNetwork':
                return 'contactNetworkText';
            default:
                return 'Gostaria de entender qual plano se encaixa no perfil da sua empresa?';
            }
        },
        closeBanner() {
            this.$emit('close', false);
        },
        actionButton() {
            if (this.supplierData.isCrossSeller) {
                this.$router.push({ name: 'BalancePurchase' });
            } else {
                this.openSubscriptionAlertModal();
            }
        },
        openSubscriptionAlertModal() {
            this.showModalSubscription = true;
        },
        closePaymentPendingBanner() {
            this.$emit('closeSubscriptionPendingModal', false);
        }
    },
    computed: {
        ...mapState('user', ['supplierData', 'user'])
    }
};
</script>

<style lang="scss" scoped>
.banner {
    background-color: #26ade2;
    color: #fff;
    padding-bottom: 28px;
    padding-top: 28px;
    position: relative;
    top: -50px;
    z-index: 0 !important;
}
.banner-supplier {
    padding-left: 15px;
    margin-left: -35px;
    margin-right: -46px;
    display: flex;
    top: 0px !important;
    flex-direction: row;
}
// .banner.black-banner {
//     background-color: #000;
// }
.banner.black-banner .open-banner-modal {
    background-color: var(--color--yellow) !important;
    color: #000 !important;
    font-weight: 600;
}

.banner > .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.banner > .container.flex-end {
    justify-content: flex-end;
}

.close-banner,
.close-payment-pending-banner {
    cursor: pointer;
    font-size: 20px;
}
.close-banner:hover,
.close-payment-pending-banner:hover {
    font-size: 24px;
    color: red;
}

.banner .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.banner .content > .text {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    margin-right: 14px;
}

.banner .content .title {
    font-size: 18px;
    font-weight: 700;
}

.banner .content .description {
    font-size: 16px;
}

.banner .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 992px) {
    .banner {
        padding-bottom: 20px;
        padding-top: 20px;
    }

    .banner .content {
        flex-direction: column;
    }

    .banner > .container {
        flex-direction: column;
        width: 90% !important;
    }

    .banner .content > .text {
        margin-bottom: 8px;
    }

    .button-container {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        align-items: center;
        width: 100%;
    }

    .close-icon {
        display: flex;
        justify-content: flex-end;
        height: fit-content;
    }

    .close-icon-wrapper {
        display: flex;
        justify-content: flex-start;
    }
}

.payment-pending-banner {
    background-color: #f5b500;
    padding-bottom: 12px;
    padding-top: 12px;
}

.payment-pending-banner.content > .text {
    flex-direction: row;
}

.payment-pending-banner .content .title {
    font-size: 16px;
}

.subscription-banner .close-icon-wrapper {
    margin-right: 18px;
}

.contact-network-banner {
    top: 0px !important;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-bottom: 0;
}

.plans-banner.banner .content .title {
    font-weight: 400;
    margin-right: 64px;
}
</style>